import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { User } from '../../store/authentication/model/user.model';
import { UserManagementActions, UserManagementApiActions } from '../../store/user-management/user-management.actions';
import { mergeMap, Observable, of } from 'rxjs';
import { selectedUsers, showSelectedUsers, tableData } from '../../store/user-management/user-management.selector';
import { TableRequest } from '../../models/table/table-request.model';
import { TableResponse } from '../../models/table/table-response.model';
import { NewUser } from '../../models/user-management/new-user.model';
import { Actions, ofType } from '@ngrx/effects';
import { UserMessageDTO } from '../../models/user-management/user-message-dto.model';

@Injectable({
    providedIn: 'root'
})
export class UserManagementFacadeService {
    tableData$: Observable<TableResponse<User>> = this.store.select(tableData);

    showSelectedUsers$: Observable<boolean> = this.store.select(showSelectedUsers);

    selectUsers$: Observable<TableResponse<User>> = this.store.select(selectedUsers);

    constructor(
        private store: Store,
        private actions$: Actions
    ) {}

    updateAllSelectedUsers(users: User[]) {
        this.store.dispatch(UserManagementActions.updateAllSelectedUsers({ users }));
    }
    updateUser(user: NewUser, changePassword: boolean): Observable<boolean> {
        this.store.dispatch(UserManagementApiActions.updateUser({ user, changePassword }));
        return this.actions$.pipe(
            ofType(UserManagementActions.updateUserSuccess, UserManagementActions.updateUserFailure),
            mergeMap((action) => {
                if (action.type === UserManagementActions.updateUserFailure.type) {
                    throw action.error;
                } else {
                    return of(true);
                }
            })
        );
    }
    createUser(user: NewUser, isGuestAccount: boolean): Observable<boolean> {
        this.store.dispatch(UserManagementApiActions.createUser({ user, isGuestAccount }));
        return this.actions$.pipe(
            ofType(UserManagementActions.createUserSuccess, UserManagementActions.createUserFailure),
            mergeMap((action) => {
                if (action.type === UserManagementActions.createUserFailure.type) {
                    throw action.error;
                } else {
                    return of(true);
                }
            })
        );
    }
    loadUsers(request: TableRequest) {
        this.store.dispatch(UserManagementApiActions.loadUsers({ request }));
    }
    changeUserTableData() {
        this.store.dispatch(UserManagementActions.changeUserTableData());
    }
    deleteUsers(userIds: number[]) {
        this.store.dispatch(UserManagementApiActions.deleteUsers({ userIds }));
    }

    sendMessageToUsers(message: UserMessageDTO) {
        this.store.dispatch(UserManagementApiActions.sendMessage({ message }));
    }

    removeSelectedUser(userToRemove: User) {
        this.store.dispatch(UserManagementActions.removeSelectedUser({ userToRemove }));
    }
}
